<template>
<b-card header='AndyMark Cash' v-if="items.length > 0">
  <b-table striped hover :fields=fields :items=items>
    <template slot=value slot-scope=data>
      <p>{{data.item.value | formatDollars}}</p>
    </template>
  </b-table>

  <b-row class=mb-2>
    <b-col cols=4>
      <p v-if="items[0].emailed">
        Emailed: {{items[0].emailed}}
      </p>
      <p v-else>
        <b>Not Emailed</b>
      </p>
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import axios from 'axios'
const BASE_API = process.env.VUE_API_ROOT

export default {
  props: {
    order: { type: Object, required: true },
  },
  data() {
    return {
      fields: {
        code: { sortable: true },
        value: { sortable: true },
        start: { },
        expiration: { },
        emailed: { thClass: 'd-none', tdClass: 'd-none' }
      },
      items: [ ]
    };
  },
  mounted() {
    axios.get(`${BASE_API}/am-old-db/am-cash/${this.order.num}`).then(response => {
      this.items = response.data
    }).catch(error => {
      console.error(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/AMCash.vue